<template>
  <v-dialog width="500px" v-model="show" @click:outside="$store.commit('close_edit_submission_dialog')">
    <v-card>
      <validation-observer v-slot="{ invalid }">
        <v-card-title>
          ویرایش اثر
        </v-card-title>
        <v-card-text @click="me">
          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-text-field v-model="edit_value.title" :error-messages="errors" color="accent" label="نام فارسی اثر"
                          outlined>
            </v-text-field>
          </validation-provider>
          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-text-field v-model="edit_value.title_en" :error-messages="errors" color="accent" label="نام لاتین اثر"
                          outlined>
            </v-text-field>
          </validation-provider>

          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-textarea v-model="edit_value.description" :error-messages="errors" color="accent" outlined
                        label="خلاصه فیلم" rows="4" required>
            </v-textarea>
          </validation-provider>
<!--          <validation-provider-->
<!--              v-slot="{ errors }"-->
<!--              rules="required|time"-->
<!--          >-->
<!--            <v-text-field-->
<!--                required-->
<!--                label="مدت زمان اثر"-->
<!--                v-model="edit_value.duration"-->
<!--                :error-messages="errors"-->
<!--                placeholder="3:34"-->
<!--            />-->
<!--          </validation-provider>-->

          <validation-provider
              v-slot="{ errors }"
              rules="required">
            <v-text-field v-model="edit_value.creation_year" :error-messages="errors" color="accent"
                          label="سال تولید اثر" outlined>
            </v-text-field>
          </validation-provider>

          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-select v-model="edit_value.category" :error-messages="errors" color="accent"
                      :items="categories"
                      item-text="name"
                      item-value="value"
                      outlined label="قالب اثر"
            ></v-select>
          </validation-provider>
          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-select v-model="edit_value.type" :error-messages="errors" color="accent"
                      :items="submission_types"
                      item-text="name"
                      item-value="value"
                      outlined label="دسته بندی مسابقه"
            ></v-select>
          </validation-provider>
          <Uploader v-if="show" :is_required="true" :document="edit_value.document"
                    :url="$store.state.base_url+'/submissions/document/upload/'"
                    accept="*" @upload_succeed="set_document" @is_uploading="uploading"/>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="$store.commit('close_edit_submission_dialog')">
            لغو
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="invalid || is_uploading" @click="update_submission">
            ویرایش
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>

</template>


<script>
import {mapState} from "vuex";
import Uploader from "@/components/submit/steps/Uploader";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  extend,
} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import static_config from "@/components/common/Statics";


setInteractionMode("aggressive");

extend("required", {
  ...required,
  message: "پر کردن این قسمت اجباریست",
});

export default {
  name: "EditSubmissionDialog"
  , props: {
    is_admin: {
      type: Boolean,
      default: true
    }
  }
  ,
  computed: {
    categories() {
      if (this.user_type === 1)
        return this.student_categories
      else if (this.user_type === 3)
        return this.all_categories
      else
        return this.teacher_categories
    },
    submission_types(){
       if (this.user_type === 3) //others = user_type
            return this.submission_type.slice(2)
        else {
         if (this.user_type === 1)
           return this.submission_type.slice(0, 1)
         else
           return this.submission_type.slice(1)
             }
    },
    ...mapState({
      show: state => state.Admin.settings.edit_submission_dialog.show,
      edit_value: state => state.Admin.settings.edit_submission_dialog.object,
      user_type: state => state.Admin.admin.data.submitter.user_type
      // loading: state => state.Submit.edit_dialog.loading
    })
  },
  data() {
    return {
      is_uploading: false,
      student_categories: static_config.student_categories,
      submission_type: static_config.submission_types,
      teacher_categories: static_config.teacher_categories,
      all_categories: static_config.all_categories,
    }
  },
  components: {
    Uploader,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    me() {
      console.log(this.edit_value);
    },
    update_submission() {
      if (this.is_admin) {
        this.$store.dispatch('update_submission_admin', this.edit_value).then(() => {
          // this.$store.commit('show_snackbar', {
          //   text: 'با موفقیت ویرایش شد.',
          //   type: 1
          // })
          // this.$store.commit('close_edit_dialog');
        });
      } else {
        this.$store.dispatch('update_submission', {isAdmin: this.is_admin}).then(() => {
          this.$store.commit('close_edit_dialog');
          this.$store.commit('show_snackbar', {
            text: 'با موفقیت ویرایش شد.',
            type: 1
          })
        });
      }
    },
    set_document(document) {
      this.edit_value.document = document;
      this.$store.commit('uploading_done')
    },
    uploading(is_uploading) {
      this.is_uploading = is_uploading;
      this.$store.commit('file_uploading')
    }
  }
}
</script>

<style scoped>

</style>